// Modelo Dinamico para monitoreo.

//TIPO 0: Solo LABEL
//{valor:"", descripcion:"", tipo:0 ,label:"g. Exposiciones en trabajos anteriores (ver HCU):",label2:"Tipo Detalle"},

//TIPO 1: select con opciones
//{valor:"", descripcion:"", tipo:1 ,label:"a. Datos de filiación:" ,data:["SI","NO"]},

//TIPO 2: Select con opciones y un campo con descripcion
//{valor:"", descripcion:"", valor2:"", tipo:2 ,label:"Discoteca:",data:["SI","NO"],label2:"veces/mes"},

//TIPO 3: Campo para observaciones inputText
//{valor:"", descripcion:"", tipo:3 ,label:"Valor:"},

//TIPO 4: Campo para observaciones textArea
//{valor:"", descripcion:"", tipo:4 ,label:"Valor:"},

export default class MonitoreoNutricionalCs {
    fecha={}
    lista=[
        {
            encabezado:"1. Información personal y laboral",
            datos:[
                {valor:"", descripcion:"", tipo:21 ,label:"      C.I.: 1721930442", bold:false},
                {valor:"", descripcion:"", tipo:22 ,label:"      Edad: 32", bold:false},
                {valor:"", descripcion:"", tipo:23 ,label:"      Apellidos y nombres: LOPEZ CRISTIAN", bold:false},
                {valor:"", descripcion:"", tipo:24 ,label:"      Empresa: PRIVADOS", bold:false},
                {valor:"", descripcion:"", tipo:25 ,label:"      Puesto de trabajo: PRIVADO", bold:false},
            ]
        },
        {
            encabezado:"2. Antecedentes personales",
            datos:[
                {valor:"", descripcion:"", tipo:1 ,label:"a. Diabetes" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"b. Hipotiroidismo" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"c. Hipertiroidismo" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"d. HTA" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:0 ,label:"e. Cirugías gastrointestinales"},
                {valor:"", descripcion:"", tipo:1 ,label:"i. Esófago",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"ii. Vesícula",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"iii. Páncreas",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"iv. Estómago",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"v. Intestino delgado",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"vi. Colon",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"vii. Recto",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"viii. Otro",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"Especifique:"},
                {valor:"", descripcion:"", tipo:1 ,label:"f. Alergias a alimentos",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"Especifique:"},
                {valor:"", descripcion:"", tipo:1 ,label:"g. Dislipidemia",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"h. Gastritis",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"i. Hígado graso",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"j. Tumores",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"Especifique:"},
                {valor:"", descripcion:"", tipo:1 ,label:"k. Estreñimiento",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"Especifique:"},
                {valor:"", descripcion:"", tipo:1 ,label:"l. Diarrea",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"Especifique:"},
                {valor:"", descripcion:"", tipo:1 ,label:"m. Otras enfermedades digestivas",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"Especifique:"},
                {valor:"", descripcion:"", tipo:1 ,label:"n. Medicación",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"Especifique (Cuál, dosis):"}
            ]
        },
        {
            encabezado:"3. Antecedentes familiares",
            datos:[
                {valor:"", descripcion:"", tipo:1 ,label:"a. Obesidad",  data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"b. Dislipidemias",  data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"c. Otros trastornos alimentarios o de digestión",  data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"Especifique:"},
            ]
        },
        {
            encabezado:"4. Estilo de vida",
            datos:[
                {valor:"", descripcion:"", tipo:1 ,label:"a. Tipo de actividad en el trabajo", data:["Ligero","Moderado","Pesado","Muy pesado"]},
                {valor:"", descripcion:"", tipo:1 ,label:"b. Actividad deportiva", data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Especifique:", data:["1 vez/semana","2-3 veces-semana","Más de 3 veces por semana","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Duración:", data:["Menos de 30 minutos","30-40 minutos","Más de 40 minutos","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"c. Consume alcohol (ver HCU)", data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"Especifique:"},
                {valor:"", descripcion:"", tipo:1 ,label:"d. Fuma (ver HCU)", data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"Especifique:"},
            ]
        },
        {
            encabezado:"5. Hábitos de alimentación",
            datos:[
                {valor:"", descripcion:"", tipo:3 ,label:"a. Número de comidas al día:"},
                {valor:"", descripcion:"", tipo:1 ,label:"b. Desayuno", data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"c. Almuerzo", data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"d. Cena", data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"e. Refrigerio", data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"Cuántos:"},
                {valor:"", descripcion:"", tipo:1 ,label:"f. Cuántos platos en cada comida", data:["Uno (Sopa o plato fuerte)","Dos (Sopa y plato fuerte)","Tres (Sopa, plato fuerte, postre)","Cuatro (Entrada, sopa, plato fuerte y postre)"]},
                {valor:"", descripcion:"", tipo:1 ,label:"g. Come en casa", data:["SI","NO","A veces"]},
                {valor:"", descripcion:"", tipo:3 ,label:"Especifique cuántas veces a la semana:"},
                {valor:"", descripcion:"", tipo:1 ,label:"h. Come fuera de casa", data:["SI","NO","A veces"]},
                {valor:"", descripcion:"", tipo:3 ,label:"Especifique cuántas veces a la semana:"},
                {valor:"", descripcion:"", tipo:0 ,label:"i. Se restringe de algún tipo de alimento:"},
                {valor:"", descripcion:"", tipo:1 ,label:"1. Carnes", data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"2. Carbohidratos", data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"3. Lácteos", data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"4. Frutas/verduras", data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"5. Otro", data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"Especifique:"},
                {valor:"", descripcion:"", tipo:1 ,label:"j. Come frutas", data:["1 vez al dia minimo","2-3 veces a la semana","Todos los dias"]},
                {valor:"", descripcion:"", tipo:1 ,label:"k. Condimenta mucho la comida", data:["SI","NO","A veces"]},
                {valor:"", descripcion:"", tipo:1 ,label:"l. Consume alimentos frescos", data:["Siempre","Nunca","A veces"]},
                {valor:"", descripcion:"", tipo:1 ,label:"m. Consume alimentos congelados", data:["Siempre","Nunca","A veces"]},
                {valor:"", descripcion:"", tipo:1 ,label:"n. Apetito", data:["Bueno","Regular","Malo"]},
                {valor:"", descripcion:"", tipo:1 ,label:"o. Intolerante a algún medicamento", data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"Especifique:"},
                {valor:"", descripcion:"", tipo:1 ,label:"p. Suplementos", data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"Especifique:"},
                {valor:"", descripcion:"", tipo:1 ,label:"q. Complementos", data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"Especifique:"},
                {valor:"", descripcion:"", tipo:1 ,label:"r. Cuántos vasos de agua al día", data:["1 vaso","2-4 vasos","5-8 vasos","Más de 8 vasos"]},
                {valor:"", descripcion:"", tipo:1 ,label:"s. Ha realizado dieta", data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"¿Por qué?:"},
                {valor:"", descripcion:"", tipo:3 ,label:"Tiempo de realizacion de la dieta:"},
                {valor:"", descripcion:"", tipo:1 ,label:"Seguimiento nutricional:", data:["SI","NO"]},
            ]
        },
        {
            encabezado:"6. Mediciones",
            datos:[
                {valor:"", descripcion:"", tipo:0 ,label:"a. Gasto energético", bold: true },
                {valor:"", descripcion:"", tipo:0 ,label:"i. Mujeres: 655+(9,6 x peso) + (1,7 x altura) - (4,7 x edad)" },
                {valor:"", descripcion:"", tipo:0 ,label:"ii. Hombres: 66,5+(13,8 x peso) + (5 x altura) - (6,8 x edad)" },
                {valor:"", descripcion:"", tipo:13 },
                {valor:"", descripcion:"", tipo:0 ,label:"b. Antropometria", bold: true },
                {valor:"", descripcion:"", tipo:3 ,label:"i. Peso" },
                {valor:"", descripcion:"", tipo:3 ,label:"ii. Talla" },
                {valor:"", descripcion:"", tipo:3 ,label:"iii. IMC" },
                {valor:"", descripcion:"", tipo:3 ,label:"iv. Perímetro abdominal:" },
                {valor:"", descripcion:"", tipo:0 ,label:"c. Medición de pliegues" },
                {valor:"", descripcion:"", tipo:7 ,valor1:"",valor2:"",valor3:"",valor4:"",valor5:"",valor6:"",valor7:"",valor8:"",valor9:"",valor10:"",valor11:"",valor12:"",valor13:"",valor14:"",valor15:"",valor16:""},
                {valor:"", descripcion:"", tipo:3 ,label:"d. % Total grasa corporal" },
                {valor:"", descripcion:"", tipo:3 ,label:"e. % Total grasa magra" },
            ]
        },
        {
            encabezado:"7. Conclusiones del estado de salud",
            datos:[
                {valor:"", descripcion:"", tipo:4 ,label:"" },
            ]
        },
        {
            encabezado:"8. Recomendaciones en el campo de la salud (seguimiento, interconsulta, medidas de protección, capacitación).",
            datos:[
                {valor:"", descripcion:"", tipo:4 ,label:"" },
            ]
        },
    ]
}
var today = new Date();
var dd = today.getDate();
var mm = today.getMonth() + 1; //January is 0!

var yyyy = today.getFullYear();
if (dd < 10) {
    dd = '0' + dd;
}
if (mm < 10) {
    mm = '0' + mm;
}
var today = dd + '/' + mm + '/' + yyyy;





// WEBPACK FOOTER //
// ./src/model/MonitoreoNutricionalCs.js